export default "__VITE_ASSET__8v1F8n61__"